import React, { useState } from 'react';
import { Camera, Upload, Loader2 } from 'lucide-react';

const PhotoUpload = ({ onFile, busy }) => {
  const [drag, setDrag] = useState(false);
  const handle = (files) => { const f = files?.[0]; if (f && !busy) onFile(f); };
  const change = (e) => { handle(e.target.files); e.target.value = ''; };
  const choiceClass = 'relative inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-semibold focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[#500000]';
  return (
    <div
      className={'relative rounded-2xl border-2 border-dashed p-6 md:p-16 text-center transition-colors ' + (drag ? 'border-[#3a190b] bg-[#f4efe9]' : 'border-[#3a190b]/30 bg-white')}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); handle(e.dataTransfer.files); }}
      data-testid="photo-upload"
    >
      <div className="w-16 h-16 mx-auto rounded-full bg-[#3a190b] text-white flex items-center justify-center mb-5">
        {busy ? <Loader2 className="h-7 w-7 animate-spin" /> : <Camera className="h-7 w-7" />}
      </div>
      <h2 className="text-xl md:text-2xl font-bold text-[#202020] mb-2">Stap 1 — Kies een foto van uw ruimte</h2>
      <p className="text-sm text-[#202020]/65 max-w-md mx-auto mb-6">Badkamer, keuken, woonkamer, slaapkamer, zolder… Neem de foto vanuit de deuropening zodat zoveel mogelijk van de ruimte zichtbaar is. JPG, PNG of HEIC, max. 12 MB. Uw foto wordt enkel gebruikt voor dit ontwerp.</p>
      <div className="flex flex-col sm:flex-row justify-center gap-3">
        <label className={choiceClass + ' bg-[#3a190b] hover:bg-[#500000] text-white ' + (busy ? 'opacity-60' : 'cursor-pointer')}>
          <Upload className="h-4 w-4" aria-hidden="true" />{busy ? 'Uploaden…' : 'Foto uploaden'}
          <input type="file" accept="image/*,.heic,.heif" disabled={busy} onChange={change} aria-label="Foto uploaden uit uw fotobibliotheek" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-wait" data-testid="photo-upload-input" />
        </label>
        <label className={choiceClass + ' border-2 border-[#3a190b] text-[#3a190b] bg-white ' + (busy ? 'opacity-60' : 'cursor-pointer')}>
          <Camera className="h-4 w-4" aria-hidden="true" />Foto maken
          <input type="file" accept="image/*" capture="environment" disabled={busy} onChange={change} aria-label="Foto maken met uw camera" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-wait" data-testid="photo-camera-input" />
        </label>
      </div>
      <p className="mt-4 text-xs text-[#202020]/60">Kies een bestaande foto of gebruik de camera van uw gsm. Op computer kunt u ook een foto hierheen slepen.</p>
    </div>
  );
};

export default PhotoUpload;
